import { Text } from '@belong/ui';

import clsx from 'clsx';

import css from './section-slice.module.css';

type SectionSliceProps = {
  primary: {
    title: { text: string }[];
    subtitle: { text: string }[];
    greenline: boolean;
    title_alignment: string;
  };
};

export function SectionSlice({ primary }: SectionSliceProps): JSX.Element {
  if (!primary) return <></>;

  const {
    title = [],
    subtitle = [],
    greenline,
    title_alignment: titleAlign,
  } = primary;
  const textAlignClassName = { 'text-center': titleAlign !== 'Left' };

  return (
    <div
      className={clsx('mb-xl mt-3xl w-full', {
        'flex flex-col items-center': titleAlign !== 'Left',
      })}
    >
      <div className="mb-sm">
        <Text
          variant="h2"
          fontWeight="semibold"
          className={clsx(textAlignClassName)}
        >
          {title[0]?.text}
        </Text>
      </div>
      <Text variant="h3" className={clsx(textAlignClassName)}>
        {subtitle[0]?.text}
      </Text>
      {greenline && (
        <div
          className={clsx(
            css.greenline,
            'mt-sm w-5xl border-3 border-green border-solid',
          )}
        />
      )}
    </div>
  );
}
